module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tests"
  }, [_c('div', {
    staticClass: "test"
  }, [_c('h3', [_vm._v("Test 1: Order Is Maintained")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.testOrderComplete),
      expression: "!testOrderComplete"
    }],
    staticClass: "test-spinner"
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'results': true, 'show': _vm.testOrderComplete
    }
  }, [_vm._m(0), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.orderedSet))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.expectedOrderedSet))]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.resultOrderedSet))]), _vm._v(" "), (_vm.testOrderStatus) ? _c('p', {
    staticClass: "pass"
  }, [_vm._v("✔ Passed")]) : _c('p', {
    staticClass: "fail"
  }, [_vm._v("× Failed")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "test"
  }, [_c('h3', [_vm._v("Test 2: Efficiancy")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('spinner', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.testEfficiencyComplete),
      expression: "!testEfficiencyComplete"
    }],
    staticClass: "test-spinner"
  })], 1), _vm._v(" "), _c('div', {
    class: {
      'results': true, 'show': _vm.testEfficiencyComplete
    }
  }, [_c('p', [_c('strong', [_vm._v("Input List Length:")]), _vm._v(" " + _vm._s(_vm.largeSet.length))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Expected List Length:")]), _vm._v(" " + _vm._s(_vm.expectedLargeSetLength))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Result List Length:")]), _vm._v(" " + _vm._s(_vm.resultLargeSet.length))]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Execution Time:")]), _vm._v(" " + _vm._s(this.executionTime) + " ms")]), _vm._v(" "), (_vm.testEfficiencyStatus) ? _c('p', {
    staticClass: "pass"
  }, [_vm._v("✔ Passed")]) : _c('p', {
    staticClass: "fail"
  }, [_vm._v("× Failed")])])], 1), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.tested
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Run Again")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Input List:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Expected List:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Result List:")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47eb594c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tests.vue
// module id = 105
// module chunks = 1